<!-- Main Container with constrained width -->
<div class="w-full max-w-full">
  <!-- Compact Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <!-- View mode buttons -->
      <div class="flex items-center gap-1.5">
        <!-- Owner filter toggle -->
        <div
          class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
        >
          <button
            type="button"
            (click)="setOwnerFilter('all')"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="
              filtroOwner === 'all'
                ? 'bg-brand-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            "
          >
            Todos
          </button>
          <button
            type="button"
            (click)="setOwnerFilter('mine')"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="
              filtroOwner === 'mine'
                ? 'bg-brand-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            "
          >
            Mis empresas
          </button>
        </div>
        <!-- inc37 — orden de las secciones: Ciclo, Estado de Lead, Sector, Tipo de Relación -->
        <button
          type="button"
          (click)="changeViewMode('cycle')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="
            viewMode === 'cycle'
              ? 'bg-brand-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          "
        >
          Ciclo
        </button>
        <button
          type="button"
          (click)="changeViewMode('stateLead')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="
            viewMode === 'stateLead'
              ? 'bg-brand-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          "
        >
          Estado Lead
        </button>
        <button
          type="button"
          (click)="changeViewMode('sector')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="
            viewMode === 'sector'
              ? 'bg-brand-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          "
        >
          Sector
        </button>
        <button
          type="button"
          (click)="changeViewMode('relationshipType')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="
            viewMode === 'relationshipType'
              ? 'bg-brand-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          "
        >
          Tipo Relación
        </button>
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            ></path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>
        <button
          type="button"
          (click)="vistaLista()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 10h16M4 14h16M4 18h16"
            ></path>
          </svg>
          Lista
        </button>
        <button
          type="button"
          (click)="nuevaEmpresa()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4v16m8-8H4"
            ></path>
          </svg>
          Nueva
        </button>
      </div>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
    <div
      class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda por nombre -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por nombre
          </label>
          <input
            type="text"
            [(ngModel)]="filters.searchTerm"
            (ngModelChange)="applyFilters()"
            placeholder="Nombre comercial..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Ciclo (solo si no es el modo actual) -->
        @if (availableFilterFields.cycle) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Ciclo
            </label>
            <select
              [(ngModel)]="filters.idCompanyCycle"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (cycle of companyCycles; track cycle.id) {
                <option [ngValue]="cycle.id">{{ cycle.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Estado Lead (solo si no es el modo actual) -->
        @if (availableFilterFields.stateLead) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Estado Lead
            </label>
            <select
              [(ngModel)]="filters.idCompanyStateLead"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (stateLead of stateLeads; track stateLead.id) {
                <option [ngValue]="stateLead.id">{{ stateLead.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Sector (solo si no es el modo actual) -->
        @if (availableFilterFields.sector) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Sector
            </label>
            <select
              [(ngModel)]="filters.idCompanySector"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (sector of sectors; track sector.id) {
                <option [ngValue]="sector.id">{{ sector.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Tipo de Relación (solo si no es el modo actual) -->
        @if (availableFilterFields.relationshipType) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Tipo de Relación
            </label>
            <select
              [(ngModel)]="filters.idCompanyRelationshipType"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (type of relationshipTypes; track type.id) {
                <option [ngValue]="type.id">{{ type.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Tamaño -->
        @if (availableFilterFields.size) {
          <div>
            <label
              class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Tamaño
            </label>
            <select
              [(ngModel)]="filters.idCompanySize"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              <option [ngValue]="undefined">Todos</option>
              @for (size of sizes; track size.id) {
                <option [ngValue]="size.id">{{ size.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro País (por prefijo telefónico) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            País
          </label>
          <app-country-select
            [countries]="filterCountries"
            [value]="filtroPais"
            [clearable]="true"
            placeholder="Todos"
            (valueChange)="onCountryFilterChange($event)" />
        </div>

        <!-- Botón Limpiar Filtros -->
        <div class="flex items-end">
          <button
            type="button"
            (click)="clearFilters()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading State -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"
      ></div>
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <div
      class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6"
    >
      {{ error }}
    </div>
  }

  <!-- Kanban Board with Horizontal Scroll -->
  @if (!loading && !error) {
    <div class="kanban-container overflow-x-auto w-full">
      <div
        class="flex gap-4 pb-4"
        style="min-width: fit-content"
      >
        @for (column of columns; track column.id; let colIndex = $index) {
          <div
            class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-72 w-72 shrink-0"
          >
            <!-- Header de la columna -->
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center gap-2">
                <div class="w-3 h-3 rounded-full {{ column.color }}"></div>
                <h3 class="font-semibold text-gray-900 dark:text-white">
                  {{ column.name }}
                </h3>
              </div>
              <span
                class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded"
              >
                {{ column.companies.length }} empresas
              </span>
            </div>

            <!-- Lista de empresas con drag & drop -->
            <div
              cdkDropList
              [id]="'col-' + column.id"
              [cdkDropListData]="column.companies"
              [cdkDropListConnectedTo]="getColumnIds()"
              (cdkDropListDropped)="drop($event, column)"
              class="min-h-125 max-h-175 overflow-y-auto space-y-3"
            >
              @for (company of column.companies; track company.id) {
                <div
                  cdkDrag
                  (click)="verDetalle(company)"
                  class="bg-white dark:bg-gray-900 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow relative group cursor-pointer"
                >
                  <!-- Botones de acción -->
                  <div
                    class="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10"
                  >
                    <button
                      type="button"
                      (click)="
                        editarEmpresa(company, $event); $event.stopPropagation()
                      "
                      (mousedown)="$event.stopPropagation()"
                      class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                      title="Editar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="
                        eliminarEmpresa(company, column, $event);
                        $event.stopPropagation()
                      "
                      (mousedown)="$event.stopPropagation()"
                      class="p-1.5 bg-error-500 hover:bg-error-600 text-white rounded transition-colors cursor-pointer"
                      title="Eliminar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>

                  <!-- Nombre comercial -->
                  <h4
                    class="font-medium text-gray-900 dark:text-white mb-2 pr-20"
                  >
                    {{ company.commercialName }}
                  </h4>

                  <!-- Nombre legal (si difiere) -->
                  @if (
                    company.businessName &&
                    company.businessName !== company.commercialName
                  ) {
                    <div class="text-sm text-gray-600 dark:text-gray-400 mb-2">
                      {{ company.businessName }}
                    </div>
                  }

                  <!-- Teléfono -->
                  @if (company.phone) {
                    <div
                      class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        ></path>
                      </svg>
                      @if (countryFlagCode(company.phone); as cc) {
                        <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(company.phone)"></span>
                      }
                      <span>{{ company.phone }}</span>
                    </div>
                  }

                  <!-- Website -->
                  @if (company.website) {
                    <div
                      class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-3"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                        ></path>
                      </svg>
                      <span class="truncate">{{ company.website }}</span>
                    </div>
                  }

                  <!-- Badges según el modo de vista -->
                  <div class="flex flex-wrap gap-2 mt-3">
                    @if (
                      viewMode !== 'stateLead' && company.idCompanyStateLead
                    ) {
                      <app-badge
                        color="info"
                        size="sm"
                        >{{
                          getStateLeadName(company.idCompanyStateLead)
                        }}</app-badge
                      >
                    }
                    @if (viewMode !== 'sector' && company.idCompanySector) {
                      <app-badge
                        color="success"
                        size="sm"
                        >{{ getSectorName(company.idCompanySector) }}</app-badge
                      >
                    }
                    @if (
                      viewMode !== 'relationshipType' &&
                      company.idCompanyRelationshipType
                    ) {
                      <app-badge
                        color="warning"
                        size="sm"
                        >{{
                          getRelationshipTypeName(
                            company.idCompanyRelationshipType
                          )
                        }}</app-badge
                      >
                    }
                    @if (viewMode !== 'cycle' && company.idCompanyCycle) {
                      <app-badge
                        color="light"
                        size="sm"
                        >{{ getCycleName(company.idCompanyCycle) }}</app-badge
                      >
                    }
                  </div>

                  <!-- Indicador de arrastre -->
                  <div
                    class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-center"
                  >
                    <div
                      class="w-8 h-1 bg-gray-300 dark:bg-gray-600 rounded"
                    ></div>
                  </div>
                </div>
              }

              <!-- Estado vacío -->
              @if (column.companies.length === 0) {
                <div
                  class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600"
                >
                  <svg
                    class="w-12 h-12 mb-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    ></path>
                  </svg>
                  <p class="text-sm">No hay empresas</p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (globalTotalPages >= 1) {
      <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
        <div class="flex items-center justify-between gap-4 flex-wrap">
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500 dark:text-gray-400">
              {{ globalTotalElements }} registros
            </span>
            <select
              [ngModel]="pageSize"
              (ngModelChange)="changePageSize($event)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            >
              @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                <option [value]="opt">{{ opt }}</option>
              }
            </select>
          </div>
          <div class="flex items-center gap-2">
            <button
              type="button"
              (click)="cambiarPagina(globalPage - 1)"
              [disabled]="!hasPrevPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Anterior
            </button>
            <div class="flex items-center gap-1.5">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >Página</span
              >
              <select
                [ngModel]="pageDisplay"
                (ngModelChange)="cambiarPagina($event - 1)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (p of pagesArray; track p) {
                  <option [value]="p">{{ p }}</option>
                }
              </select>
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >de {{ globalTotalPages }}</span
              >
            </div>
            <button
              type="button"
              (click)="cambiarPagina(globalPage + 1)"
              [disabled]="!hasNextPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    }
  }

  <!-- Modal de detalle -->
  <app-empresa-detail-modal
    [isOpen]="showDetailModal"
    [company]="selectedCompany"
    [stateLeads]="stateLeads"
    [sectors]="sectors"
    [taxTypes]="taxTypes"
    [sizes]="sizes"
    [relationshipTypes]="relationshipTypes"
    [cycles]="companyCycles"
    (close)="cerrarModalDetalle()"
  >
  </app-empresa-detail-modal>
</div>
